import { render, staticRenderFns } from "./handzettelFront.vue?vue&type=template&id=154cf4ab&scoped=true&"
import script from "./handzettelFront.vue?vue&type=script&lang=js&"
export * from "./handzettelFront.vue?vue&type=script&lang=js&"
import style0 from "./handzettelFront.vue?vue&type=style&index=0&id=154cf4ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154cf4ab",
  null
  
)

export default component.exports